import { ROLES_NOT_CHECKED_IN } from '../actionTypes'

const initialState = {
  list: [],
  loading: false,
  error: null
}

export default function rolesNotCheckedInReducer(state = initialState, action) {
  switch (action.type) {
    case ROLES_NOT_CHECKED_IN.FETCH_REQUEST:
      return { ...state, loading: true, error: null }
    case ROLES_NOT_CHECKED_IN.FETCH_SUCCESS:
      return { ...state, loading: false, list: action.list, error: null }
    case ROLES_NOT_CHECKED_IN.FETCH_FAILURE:
      return { ...state, loading: false, list: [], error: action.error }
    case ROLES_NOT_CHECKED_IN.CLEAR:
      return initialState
    default:
      return state
  }
}
